module.exports = __webpack_public_path__ + "mxiaozhangxinxiang.png?46c5061d22d54afb7d1f1bbd4d6f5bc4";


//////////////////
// WEBPACK FOOTER
// ./static/assets/mxiaozhangxinxiang.png
// module id = 542
// module chunks = 0